import { createApp } from 'vue';
import WavToFlacConverter from '@/Components/WavToFlacConverter.vue';
import '@styles/app.css';

createApp(WavToFlacConverter).mount('#wav-to-flac-converter');
